/**
 * Converts _id to id in a single object.
 *
 * @param data - The input object containing an _id field.
 * @returns A new object with _id converted to id.
 */
export function convertIdInObject<T extends { _id: string }>(data: T): Omit<T, '_id'> & { id: string } {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { _id, ...rest } = data;
    return { ...rest, id: _id };
}

/**
 * Converts _id to id in an array of objects.
 *
 * @param data - The array of objects containing _id fields.
 * @returns A new array of objects with _id converted to id.
 */
export function convertIdInArray<T extends { _id: string }>(data: T[]): (Omit<T, '_id'> & { id: string })[] {
    return data.map(({ _id, ...rest }) => ({ ...rest, id: _id }));
}
